import { render, staticRenderFns } from "./TheShowPassport.vue?vue&type=template&id=89955b3a&"
import script from "./TheShowPassport.vue?vue&type=script&lang=js&"
export * from "./TheShowPassport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports